//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import IndexHeader from '@/components/IndexHeader'
import IndexSidebar from '@/components/IndexSidebar'
import IndexFooter from '@/components/IndexFooter'
export default {
  data () {
    return {
      whyChooseContent: [
        {
          imgSrc: 'https://static.xinmeibao.com/assets_mobile/solution/toutiao1.png',
          whyText: '5秒算出用户兴趣，根据兴趣智能推荐新闻；'
        },
        {
          imgSrc: 'https://static.xinmeibao.com/assets_mobile/solution/toutiao2.png',
          whyText: '手机消耗人们大量时间，看新闻排在第2位；'
        },
        {
          imgSrc: 'https://static.xinmeibao.com/assets_mobile/solution/toutiao3.png',
          whyText: '2017年8月新闻资讯APP活跃用户排行榜头条2.4亿人活跃；'
        },
        {
          imgSrc: 'https://static.xinmeibao.com/assets_mobile/solution/toutiao4.png',
          whyText: '今日头条自己也有新闻；'
        },
        {
          imgSrc: 'https://static.xinmeibao.com/assets_mobile/solution/toutiao5.png',
          whyText: '后台灵活操作，实时数据报表；'
        },
        {
          imgSrc: 'https://static.xinmeibao.com/assets_mobile/solution/toutiao6.png',
          whyText: '精准定向广告投放，让广告主的预算花的值；'
        }
      ],
      styleToutiaoContent: [
        {
          styleH3: '信息流广告',
          whyText: '原生形式  投放灵活  多维定向'
        },
        {
          styleH3: '开屏广告',
          whyText: '开机必看  全屏醒目  海量触大'
        },
        {
          styleH3: '详情页广告',
          whyText: '阅读路径拦截  成本控制  智能竞价工具'
        },
        {
          styleH3: '视频广告',
          whyText: '形式原生  超长播放   互动传播'
        }
      ],
      commonQuestionContent: [
        {
          styleH3: '01今日头条广告怎么收费？',
          whyText: '今日头条支持按照CPC、CPM的形式收费，具体收费价格，请联系我们的在线客服。'
        },
        {
          styleH3: '02今日头条广告与搜索引擎竞价广告有什么区别？',
          whyText: '今日头条广告与搜索引擎广告都具备精准定向的特点，不同的是今日头条是基于用户兴趣向用户推荐其感兴趣的内容，而搜索引擎广告是根据用户搜索词触发广告，二者在定向基于的数据方面是不同的。基于兴趣爱好的定向是基于用户潜在需求的定向，而基于搜索词的定向是基于用户及时需求的定向。'
        },
        {
          styleH3: '03今日头条广告是竞价广告吗？',
          whyText: '今日头条广告是需要竞价的，由于设置同一定向条件的广告主太多，而广告位置有限，因此需要广告主进行竞价，出价越高，获得越多的展示机会。'
        }
      ]
    }
  },
  methods: {},
  components: {
    IndexHeader,
    IndexSidebar,
    IndexFooter
  }
}



// WEBPACK FOOTER //
// ./src/pages/promotionToutiao/index.vue